import msgs from '../messages.json';

const STORAGE_KEY = 'maskr-lang';

export const getLang = () => localStorage.getItem(STORAGE_KEY) || 'fr';

export function resolve(path, obj) {
  return path.split('.').reduce((o, k) => o?.[k], obj);
}

export function apply(lang) {
  const m = msgs[lang] ?? msgs.en;
  document.documentElement.lang = lang;

  const title = document.getElementById('intro-title');
  const bullets = document.getElementById('intro-bullets');
  if (title) title.textContent = m.intro.title;
  if (bullets) bullets.innerHTML = m.intro.bullets.map(b => `<li>${b}</li>`).join('');

  document.querySelectorAll('[data-i18n]').forEach(el => {
    const val = resolve(el.dataset.i18n, m);
    if (typeof val === 'string') el.textContent = val;
  });

  const btn = document.getElementById('btn-lang');
  if (btn) btn.textContent = m.langToggle;
}

export function setLang(lang) {
  localStorage.setItem(STORAGE_KEY, lang);
  apply(lang);
}

export function toggleLang() {
  setLang(getLang() === 'en' ? 'fr' : 'en');
}
